module.exports = __webpack_public_path__ + "img/Picture2.562f38d7.jpg";